module.exports = __webpack_public_path__ + "static/media/live stream.6e209618.png";